// Safari aborts the download if the blob url is revoked right after click().
const REVOKE_BLOB_URL_DELAY_MS = 60_000;

/**
 * Saves a blob to the user's device as a file download.
 * @param blob - The file content
 * @param fileName - The suggested file name
 */
export function saveBlobAsFile(blob: Blob, fileName: string): void {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(blobUrl), REVOKE_BLOB_URL_DELAY_MS);
}
